import "./index.css";
import "@vitalsource/vst-ui-kit/layered/core/required-setup.css";
import "@vitalsource/vst-ui-kit/layered/components/link.css";
import "@vitalsource/vst-ui-kit/layered/components/button.css";
import "@vitalsource/vst-ui-kit/layered/components/tab.css";

import ReactDOM from "react-dom";
import AppMain from "./main/AppMain";

/**
 * Let's continue to keep this file as slim as possible, serving only
 * as the app entry point and providing truly global polyfills.
 * This will facilitate writing truly isolated app slices further
 * down the tree.
 */

ReactDOM.render(<AppMain />, document.getElementById("root"));
